export const TOGGLE_OVERLAY = "TOGGLE_OVERLAY";

export const toggleOverlay = (boolean) => {
  return (dispatch) => {
    dispatch({ type: TOGGLE_OVERLAY, payload: boolean });
  };
};
